import React from "react";
import { setEditId, StickerPackInterface } from "../../../../store/sticker_maker/stickerPacksSlice";
import IconText from "../../../../componets/IconText";
import {
  CheckCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  HeartOutlined,
  StopOutlined,
  SwitcherOutlined
} from "@ant-design/icons";
import { Button, ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import Meta from "../../Users/_partials/_Meta";
import CardImage from "../../../../componets/CardImage";
import { EntityId } from "@reduxjs/toolkit";
import {
  blockStickerPack,
  destroyStickerPack,
  unBlockStickerPack,
  publishStickerPack,
  unPublishStickerPack
} from "../../../../actions/sticker_maker/stickerPacksActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../store/hooks";
import { UserInterface } from "../../../../store/sticker_maker/usersSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";
import { StatusTag } from "./_Tags";

interface propsInterface {
  stickerPack: StickerPackInterface;
  user?: UserInterface | undefined;
}

const Card = ({ stickerPack, user }: propsInterface) => {
  const navigate            = useNavigate();
  const dispatch            = useAppDispatch();
  const formattedCreatedAt  = formattedDate(stickerPack.created_at);
  const options             = [
    <ButtonEdit key={`edit-${stickerPack.id}`} onClick={() => onClickEdit(stickerPack.id)} />,
    <ButtonDestroy key={`destroy-${stickerPack.id}`} onClick={() => onClickDestroy(stickerPack.id)} />
  ];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyStickerPack(id));

    if (destroyStickerPack.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyStickerPack.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function onClickUnBlock(id: number) {
    dispatch(unBlockStickerPack(id));
  }

  function onClickBlock(id: number) {
    dispatch(blockStickerPack(id));
  }

  function unPublish(id: number) {
    dispatch(unPublishStickerPack(id));
  }

  function publish(id: number) {
    dispatch(publishStickerPack(id));
  }

  if (stickerPack.status === 2) {
    options.unshift(
      <Button key={`unblock-${stickerPack.id}`} title='UnBlock' onClick={() => onClickUnBlock(stickerPack.id)} icon={CheckCircleOutlined} />
    );
  } else {
    options.unshift(
      <Button key={`block-${stickerPack.id}`} title='Block' onClick={() => onClickBlock(stickerPack.id)} icon={StopOutlined} />
    );
  }

  if (stickerPack.published) {
    options.unshift(
      <Button key={`unpublish-${stickerPack.id}`} title='UnPublish' onClick={() => unPublish(stickerPack.id)} icon={EyeInvisibleOutlined} />
    );
  } else {
    options.unshift(
      <Button key={`publish-${stickerPack.id}`} title='Publish' onClick={() => publish(stickerPack.id)} icon={EyeOutlined} />
    );
  }

  return (
    <CardImage
      image={stickerPack.image_url}
      title={stickerPack.name}
      link={stickerPack.url}
      size='medium'
      stats={[
        <IconText icon={HeartOutlined} text={stickerPack.popular_count} tooltip='popular' />,
        <IconText icon={SwitcherOutlined} text={stickerPack.stickers_count} tooltip='stickers' />,
        <IconText icon={SwitcherOutlined} text={stickerPack.active_stickers_count} tooltip='approved stickers' />
      ]}
      options={options}
      labels={[
        <StatusTag key='tag-status' status={stickerPack.status} />
      ]}
    >
      {user && <Meta user={user} size='xsmall' />}

      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
